import Globalizer from './globalizer.js';
import Yacc from './yacc';
import marketingAndAnalyticsService from './services/marketingAndAnalytics/marketingAndAnalyticsService.js';
// inizializzo le variabili globali

const debug = (message) => console.debug(message);

var Lordgun = {
    isTouch: false,
    variables: {
        _isExtraSmallScreen: true,
        _isSmallScreen: false,
        _isMediumScreen: false,
        _isLargeScreen: false,
        _isExtraLargeScreen: false,
        _isPortrait: false,
    },
    initVar: function () {
        if (window.matchMedia) {
            Lordgun.variables._isExtraSmallScreen =
                Modernizr.mq('(max-width: 48em)'); // sotto i 48em == 768px
            Lordgun.variables._isSmallScreen =
                Modernizr.mq('(min-width: 64em)'); // sopra i 64em == 1024px
            Lordgun.variables._isMediumScreen =
                Modernizr.mq('(min-width: 80em)'); // sopra i 80em == 1280px
            Lordgun.variables._isLargeScreen = Modernizr.mq(
                '(min-width: 85.4375em)'
            ); // sopra i 85.4375em == 1367px
            Lordgun.variables._isPortrait = Modernizr.mq(
                '(orientation: portrait)'
            ); // sopra i 48em
        }
        //Qui possiamo evolvere i controlli per i dispostivi touch
        Lordgun.isTouch = window.innerWidth <= 768;
        if (Lordgun.isTouch === false) {
            document.querySelector('html').classList.add('no-touch');
        }
    },

    DOMready: function () {
        //Va per primo o non binda i calendari etc. che vengono dopo
        Lordgun.initVar();
        debug('xs: ' + Lordgun.variables._isExtraSmallScreen);
        debug('s: ' + Lordgun.variables._isSmallScreen);
        debug('m: ' + Lordgun.variables._isMediumScreen);
        // debug("l: " + Lordgun.variables._isLargeScreen);

        Globalizer.init();

        if (document.querySelectorAll('#main-header').length > 0) {
            Lordgun.stickyNav();
        }
        if (
            document.querySelectorAll('.navicon').length > 0 &&
            !Lordgun.variables._isSmallScreen
        ) {
            Lordgun.navicon();
        }
        if (document.querySelectorAll('.button--wait').length > 0) {
            Array.prototype.forEach.call(
                document.querySelectorAll('button--wait'),
                (buttonWait) => {
                    buttonWait.classList.remove('button--wait');
                }
            );
        }
        if (document.querySelectorAll('.message').length > 0) {
            Lordgun.closeMessage();
        }
        if (document.querySelectorAll('.rpm-container').length > 0) {
            Array.prototype.forEach.call(
                document.querySelectorAll('.rpm-container'),
                (rpmContainer) => {
                    rpmContainer.style.display = 'none';
                    const headerHeight =
                        document.getElementById('main-header').clientHeight;
                    const bodyHeight =
                        document.querySelector('body').clientHeight;

                    setTimeout(function () {
                        rpmContainer.style.height = bodyHeight - headerHeight;
                        rpmContainer.style.display = 'block';
                    }, 150);
                }
            );
        }

        marketingAndAnalyticsService.run();
    }, //fine DOMReady

    stickyNav: function () {
        // mediaQuery needed for accessibility - if the user prefers reduced motion the navbar won't hide
        const mediaQuery = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        );
        const userOptions = document.querySelector(
            '.nav-secondary__item--user-options'
        );
        const mainHeader = document.querySelector('#main-header');
        let previousScrollPosition = 0;
        let throttleWait;

        const isScrollingDown = () => {
            let currentScrolledPosition = window.scrollY || window.pageYOffset;
            let scrollingDown;

            if (currentScrolledPosition > previousScrollPosition) {
                scrollingDown = true;
            } else {
                scrollingDown = false;
            }
            previousScrollPosition = currentScrolledPosition;
            return scrollingDown;
        };

        const throttle = (callback, time) => {
            if (throttleWait) return;
            throttleWait = true;

            setTimeout(() => {
                callback();
                throttleWait = false;
            }, time);
        };

        const handleNavScroll = () => {
            if (userOptions) {
                if (isScrollingDown()) {
                    userOptions.classList.add('hidden');
                    mainHeader.classList.add('is-fixed');
                    mainHeader.style.top = '-100%';
                } else {
                    window.scrollY === 0
                        ? userOptions.classList.remove('hidden')
                        : userOptions.classList.add('hidden');
                    window.scrollY === 0
                        ? mainHeader.classList.remove('is-fixed')
                        : mainHeader.classList.add('is-fixed');
                    mainHeader.style.top = '0';
                }
            }
        };

        window.addEventListener('scroll', () => {
            if (mediaQuery && !mediaQuery.matches) {
                throttle(handleNavScroll, 150);
            }
        });
    },

    scrollThenOpenMenu: function (navIcon) {
        const handleClick = (navIcon) => {
            navIcon.classList.toggle('is-active');

            setTimeout(function () {
                const triggerOpenButton =
                    document.getElementById('rpm-trigger');
                const triggerCloseButton = document.body;

                if (
                    navIcon.classList.contains('is-active') &&
                    triggerOpenButton !== null
                ) {
                    triggerOpenButton.click();
                } else if (triggerCloseButton !== null) {
                    triggerCloseButton.click();
                }
            }, 20);
        };

        const openMobileMenu = (event) => {
            // setTimeout(function () {
            if (window.scrollY === 0) {
                window.removeEventListener('scroll', openMobileMenu);
                const triggerOpenButton =
                    document.getElementById('rpm-trigger');
                triggerOpenButton.click();
            }
            // }, 20);

            setTimeout(function () {
                window.removeEventListener('scroll', openMobileMenu);
            }, 5000);
        };

        if (window.scrollY !== 0) {
            window.addEventListener('scroll', openMobileMenu);
            window.scroll({
                top: 0,
                behavior: 'smooth',
            });
        } else {
            handleClick(navIcon);
        }
    },
    navicon: function () {
        const navIcon = document.querySelector('.navicon');

        navIcon.onclick = (e) => {
            e.preventDefault();

            if (document.getElementById('hamburgerMenu') !== null) {
                this.scrollThenOpenMenu(navIcon);
            } else {
                e.currentTarget.classList.contains('is-active')
                    ? document
                          .querySelector('.navigation')
                          .classList.remove('is-open')
                    : document
                          .querySelector('.navigation')
                          .classList.add('is-open');

                e.currentTarget.classList.toggle('is-active');
            }
        };
    },

    closeMessage: function () {
        Array.prototype.forEach.call(
            document.querySelectorAll('.message--close'),
            (messageClose) => {
                messageClose.onclick = (e) => {
                    e.preventDefault();
                    e.currentTarget.parentElement.classList.toggle('hidden');
                };
            }
        );
    },
};

///////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function (event) {
    Lordgun.DOMready();
    if (window.cookiePageUrl) {
        let yaccInstance = new Yacc({
            cookiePageUrl: window.cookiePageUrl,
        });
        yaccInstance.handleScripts();
        yaccInstance.handleBanner();
    }
});

String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;
    while (i--)
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    return s;
};

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (search, pos) {
        return (
            this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
        );
    };
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
    module.exports.Lordgun = Lordgun;
